// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d6e9046b","145":"a073546b","270":"d9aa3233","306":"08b3d32f","307":"dda07711","601":"e625e4e6","616":"758de576","943":"cf70de73"}[chunkId] + ".chunk.js";
};